
import React, { useEffect, useState, useRef, useCallback } from 'react';
import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, RequiredRule } from 'devextreme-react/data-grid';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';
import './EntryBatchForm.scss';
import { getSizeQualifier, useScreenSize } from '../../../utils/media-query';
import { Button, ButtonGroup, Popup, Switch } from 'devextreme-react';
import { GENDERS } from '../../../shared/constants';
import { EditCellTimeComponent, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { TimeDropdownBox, TimeDropdownBoxCounter } from '../../utils/time-dropdownbox/TimeDropdownBox';
import { FormPopup } from '../../utils/form-popup/FormPopup';
import { ResultPopup } from '../result-popup/ResultPopup';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import Validator, {
    CustomRule
} from 'devextreme-react/validator';
import { alert } from 'devextreme/ui/dialog';


export const BatchEntryForm = ({ initData, onSave, allowEditing, onDataChanged }) => {

    const currentRow = useRef(null);
    const handleInfoClick = (infoText) => {
        alert(infoText, 'Info'); // Hier kannst du den Code für das Popup hinzufügen
       
    };
    const rowPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.data.entryAllowed === false) {

                e.rowElement.classList.add('disabled-rows');
                // To override alternation color
                e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");

            }
        }
    }

    const [entryData, setentryData] = useState(initData);
    const { isXSmall } = useScreenSize();
    const gridRef = useRef(null);
    useEffect(() => {
        setentryData(initData);
        gridRef.current?.instance().filter([['entryAllowed', '=', true]]);
    }, [initData]);
    const filterAllowedEvents = useRef(true);

    const valueChanged = useCallback((e) => {
        switch (e.itemData.text) {
            case 'alle Strecken anzeigen':
                filterAllowedEvents.current = !filterAllowedEvents.current;
                if (filterAllowedEvents.current) {
                    gridRef.current?.instance().filter([['entryAllowed', '=', true]]);

                } else {
                    gridRef.current?.instance().clearFilter();

                }

                break;
        }
    }, []);
    
  
    const updateData = (e) => {

        onDataChanged(entryData);
    };

    return (
        <div>
            <DataGrid
                className='entries-grid'
                dataSource={entryData.entries}
                remoteOperations={true}
                width={'100%'}
                height={isXSmall ? 'calc(100vh - 120px)' : 'calc(100vh - 280px)'}
                rowAlternationEnabled={true}
                ref={gridRef}
                onEditingStart={function (e) {
                    if (!e.data.entryAllowed) {
                        e.cancel = true;
                    }
                }}
              
                onRowPrepared={rowPrepared}
                onSaved={updateData}
               
            >
                <Editing allowUpdating={allowEditing} allowAdding={false} allowDeleting={false} mode="cell" />
                <Toolbar>
                    <Item location='before' locateInMenu='auto'>
                        <ButtonGroup
                            items={[{ icon: 'alignjustify', text: "alle Strecken anzeigen" }]}
                            selectionMode="multiple"
                            stylingMode="text"

                            onItemClick={valueChanged}
                            cssClass='group-margin'
                        />



                    </Item>
                 
                </Toolbar>
                <Paging enabled={false} />
                <Column dataField="swimstyleName" caption="Schwimmstil" width={120} allowEditing={false} fixed={true} cellRender={(cellData) => (
                    <span style={{ fontWeight: 'bold' }}>{cellData.value}</span>
                )} />
                <Column dataField="entry" caption="Meldung" dataType="boolean" width={80} >

                </Column>
             
             
                <Column dataField="eventNumber" caption="WK-Nr." width={100} allowEditing={false} />
                <Column dataField="sessionName" caption="Session" width={100} allowEditing={false} groupIndex={0} groupCellRender={(groupData) => {

                    var firstItemDate = null;
                    if (groupData.data.items?.length > 0) {
                        firstItemDate = groupData.data.items[0]?.date;
                    }
                    else if (groupData.data.collapsedItems?.length > 0) {
                        firstItemDate = groupData.data.collapsedItems[0]?.date;
                    }
                    const formattedDate = firstItemDate ? new Date(firstItemDate).toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }) : 'Kein Datum';
                    return `${groupData.text} (${formattedDate})`;
                }} />
                <Column dataField="eventRound" caption="Runde" width={150} allowEditing={false} cellRender={(cellData) => {
                    if (!filterAllowedEvents.current) {
                        const gender = GENDERS.find(g => g.id === cellData.data.eventGender)?.text || 'Unbekannt'; // Geschlecht aus GENDERS zuordnen
                        return `${cellData.value} (${gender})`;
                    }
                    else {
                        return `${cellData.value}`;
                    }
                }} />
                <Column dataField="eventGender" caption="Geschlecht" dataType='number' width={100} allowEditing={false} visible={!filterAllowedEvents} lookup={{ dataSource: GENDERS, valueExpr: 'id', displayExpr: 'text' }} />
                <Column dataField="eventOrder" caption="Reihenfolge" visible={false} allowEditing={false} sortOrder='asc' sortIndex={0} />
                <Column dataField="entryAllowed" caption="Eintrag erlaubt" dataType="boolean" allowEditing={false} width={120} visible={false} />
                <Column
                    dataField="entryAllowedInformation"
                    caption="Einschränkungen"
                    width={50}
                    allowEditing={false}
                    visible={true}
                    cellRender={(cellData) => {
                        if (cellData.value) {
                            return (
                                <i
                                    className="dx-icon-warning"
                                    style={{ cursor: 'pointer', color: '#007bff' }}
                                    onClick={() => handleInfoClick(cellData.value)}
                                />
                            );
                        }
                        return null;
                    }}
                />
            </DataGrid>
          

        </div>

    );
};
